import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { DeliveryNoteParams, ProofOfDeliveryDocuments, ProofOfDeliveryItem } from '../../models';
import { DeliveryNoteEndpoint } from '../../constants';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteProofOfDeliveryService {
  constructor(private http: WrapperHttpService) {}

  getProofOfDeliveryItem({ deliveryNoteNumber, sapId }: DeliveryNoteParams): Observable<ProofOfDeliveryItem> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http
      .withLoading()
      .get<ProofOfDeliveryItem>(
        `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.ProofOfDelivery}${params}`,
      );
  }
  downloadFile({
    deliveryNoteNumber,
    sapId,
    documentId,
  }: {
    deliveryNoteNumber: string;
    sapId: string;
    documentId: string;
  }): Observable<HttpResponse<Blob>> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';
    const url = `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.ProofOfDelivery}${DeliveryNoteEndpoint.Documents}/${documentId}${params}`;

    return this.http.get<HttpResponse<Blob>>(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  saveProofOfDeliveryItem({
    deliveryNoteNumber,
    sapId,
    proofOfDeliveryItemValue,
  }: {
    deliveryNoteNumber: string;
    sapId: string;
    proofOfDeliveryItemValue: ProofOfDeliveryDocuments;
  }): Observable<ProofOfDeliveryItem> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http
      .withLoading()
      .post<ProofOfDeliveryItem>(
        `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.ProofOfDelivery}${params}`,
        proofOfDeliveryItemValue,
      );
  }

  sendRequestProofOfDelivery({ deliveryNoteNumber, sapId }: DeliveryNoteParams): Observable<void> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http.post<void>(
      `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.ProofOfDelivery}${DeliveryNoteEndpoint.Request}${params}`,
      {},
    );
  }
}
